import React from 'react';
import './homepage.css';

const MAP_SRC =
  'https://maps.google.com/maps?q=My%20Private%20Chemist%2C%20Longcroft%20House%2C%20The%20small%20road%20between%20the%20Police%20Station%20and%20Five%20Guys%2C%202-8%20Victoria%20Ave%2C%20London%20EC2M%204NS&output=embed';

const MapSection = () => (
  <section className="hp-map">
    <div className="hp-map__container">
      <iframe
        src={MAP_SRC}
        width="1100"
        height="400"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="My Private Chemist location"
      />
    </div>
  </section>
);

export default MapSection;
